module.exports = __webpack_public_path__ + "media/src/application/media/svg/user-ee50d439cdaf869537e2bc67f874030a.svg";